export default `{{#contains (toLowerCase customer_group_name) "b2b"}}
<!-- Anything inside here only shows for logged in customers-->
<!-- Start of SparkLayer core script-->
<script>
window.sparkOptions = {
  siteId: "#SITE_ID#",#DOMAIN#
  platform: "bigcommerce",
  rootUrl: "{{ urls.home }}",
  language: "{{ locale_name }}",
  accountRedirect: {
    urlRegex: /^\\/account\\.php/g,
    goTo: "/", // page to redirect logged in users to
  },
  auth: {
    user: "{{ customer.email }}",
  },
};
</script>
<script async src="#SPARKJS_URL#"></script>
<!-- End of SparkLayer core script-->
{{/contains}}
<!-- required for linking to order or quotes: https://docs.sparklayer.io/my-account-interface#yT5mS -->
<script async src="https://cdn.sparklayer.io/spark-redirect.js"></script>`;
